import React from "react";
import { NavLink } from "react-router-dom";
export default function Nav() {
  return (
    <nav className="navbar navbar-expand-sm bg-dark navbar-dark">
      <div className="container-fluid">
        <span className="navbar-brand">
          <img
            src="https://yt3.ggpht.com/6Suhx6Wl6yWWFmY5Hg6Bxd7QiN9KWT53fENbdfgFn9QjVijXhHNn6HfrQgzgPLBdLSmbq4jLu9I=s88-c-k-c0x00ffffff-no-rj"
            style={{ width: "40px" }}
            className="rounded-pill"
            alt="logo"
          />
        </span>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapsibleNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/dashboard/editing">
                UPLOAD
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/dashboard/video">
                VIDEO
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
